module.exports = __webpack_public_path__ + "img/login-top-img.94f8d40.png";